import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

// Composants
import { DialogBaseComponent } from 'src/app/@shared/components/abstract/dialog-base.component';
import { OrganizationsListComponent } from '../organizations-list/organizations-list.component';

// Modèles
import { Client } from 'src/app/@shared/models/client/client.model';

@Component({
    selector: 'app-organizations-selector-dialog',
    imports: [
        CommonModule,
        ButtonModule,
        OrganizationsListComponent
    ],
    templateUrl: './organizations-selector-dialog.component.html',
    styleUrls: ['./organizations-selector-dialog.component.scss']
})
export class OrganizationsSelectorDialogComponent extends DialogBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    public clients: Client[] = [];

    /*----------------------------------------------------------------------------------------
     * Constructeur
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onOrganizationSelected(client: Client): void {
        this.appService.selectClient(client);
        this._dialogRef?.close();
    }

    public onClickCreateOrganization(): void {
        this._createNewClient();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override loadData(): void {
        this.loading = true;
        this.userService.loadClients$().subscribe((clients: Client[]) => {
            this.clients = clients;
            this.loading = false;
        });
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    private _createNewClient(): void {
        // Déselection du client actuellement sélectionné
        this.appService.selectedClient = null;
        this.clientService.select(new Client({}), false);
        this._dialogRef?.close();
        // Navigation vers le formulaire de création d'un nouveau client, hors
        // contexte dossier — une création n'a par définition pas d'identifiant (#173)
        this.router.navigate(['/client/new']);
    }

}
